import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Fängt die native back gesture (Android) ab, solange die Seite in einem Zustand ist, den "zurück" beenden soll
// (z.B. multi select). Statt die App zu schliessen, wird ein "native--back-handler:back" Event dispatched.

// Connects to data-controller="native--back-handler"
export default class extends BridgeComponent {
  static component = "back-handler"

  disconnect() {
    this.disable()
    super.disconnect()
  }

  // Erwartet ein Event mit detail: { active: Boolean }
  update({ detail: { active } }) {
    active ? this.enable() : this.disable()
  }

  enable() {
    if (!this.enabled || this.active) return

    this.active = true
    this.send("enable", {}, () => this.dispatch("back"))
  }

  disable() {
    if (!this.active) return

    this.active = false
    this.send("disable")
  }
}
